import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISelectedBalanceFreeze } from '@interfaces/selected-balance-freeze.interface';
import { ISolicitudResponse } from '@interfaces/solicitud-cambio-via-pago.response.interface';
import { Util } from '@shared/common/utils/util';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CongelamientoSaldoService {

  constructor(private readonly http: HttpClient, private readonly util: Util) { }

  public solicitudCambioViaPago(token:string, accountsSelected: ISelectedBalanceFreeze): Observable<ISolicitudResponse> {
    const url = `${environment.BASE_BACKEND}/client/solicitud-congelamiento-saldo`;
    const headers = this.util.getHeaders(token);
    const body = accountsSelected;
  
    return this.http.post(url, body, { headers }) as Observable<ISolicitudResponse>;
  }
}
